/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigPlaylistSelect_CustomerFragment = { __typename: 'Customer', id: string, playlists: Array<{ __typename: 'Playlist', id: string, size: any, title: string, playlistType: Types.PlaylistType }> };

export type ConfigPlaylistSelect_ConfigFragment = { __typename: 'ConfigurationModel', id: string, playlistType?: Types.PlaylistType | null, playlist?: { __typename: 'ConfigPlaylist', current?: { __typename: 'ConfigCurrentPlaylist', id: string, title: string, size: any } | null } | null };

export type ConfigUpdatePlaylistContentSourceMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdatePlaylistContentSourceInput;
}>;


export type ConfigUpdatePlaylistContentSourceMutation = { __typename: 'Mutation', configurationUpdatePlaylistContentSource: { __typename: 'ConfigurationModel', id: string } };

export const ConfigPlaylistSelect_CustomerFragmentDoc = gql`
    fragment ConfigPlaylistSelect_customer on Customer {
  id
  playlists {
    id
    size
    title
    playlistType
  }
}
    `;
export const ConfigPlaylistSelect_ConfigFragmentDoc = gql`
    fragment ConfigPlaylistSelect_config on ConfigurationModel {
  id
  playlistType
  playlist {
    current {
      id
      title
      size
      __typename
    }
    __typename
  }
}
    `;
export const ConfigUpdatePlaylistContentSourceDocument = gql`
    mutation ConfigUpdatePlaylistContentSource($input: ConfigurationUpdatePlaylistContentSourceInput!) {
  configurationUpdatePlaylistContentSource(input: $input) {
    id
  }
}
    `;
export type ConfigUpdatePlaylistContentSourceMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdatePlaylistContentSourceMutation, ConfigUpdatePlaylistContentSourceMutationVariables>;

/**
 * __useConfigUpdatePlaylistContentSourceMutation__
 *
 * To run a mutation, you first call `useConfigUpdatePlaylistContentSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdatePlaylistContentSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdatePlaylistContentSourceMutation, { data, loading, error }] = useConfigUpdatePlaylistContentSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdatePlaylistContentSourceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdatePlaylistContentSourceMutation, ConfigUpdatePlaylistContentSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdatePlaylistContentSourceMutation, ConfigUpdatePlaylistContentSourceMutationVariables>(ConfigUpdatePlaylistContentSourceDocument, options);
      }
export type ConfigUpdatePlaylistContentSourceMutationHookResult = ReturnType<typeof useConfigUpdatePlaylistContentSourceMutation>;
export type ConfigUpdatePlaylistContentSourceMutationResult = ApolloReactCommon.MutationResult<ConfigUpdatePlaylistContentSourceMutation>;
export type ConfigUpdatePlaylistContentSourceMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdatePlaylistContentSourceMutation, ConfigUpdatePlaylistContentSourceMutationVariables>;